"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Level = void 0;
var Level;
(function (Level) {
    Level["trace"] = "trace";
    Level["debug"] = "debug";
    Level["information"] = "information";
    Level["warning"] = "warning";
    Level["error"] = "error";
    Level["critical"] = "critical";
    Level["none"] = "none";
})(Level = exports.Level || (exports.Level = {}));
//# sourceMappingURL=Level.js.map